export default __webpack_public_path__ + "static/media/roar.866d594b.wav";